<template>
    <div class="back-button" id="back-button">
      <a @click="$router.back()" v-if="!link"><img src="@/assets/images/back.svg">Zurück</a>
      <router-link :to="link" v-if="link"><img src="@/assets/images/back.svg">Zurück</router-link>
    </div>
</template>

<script>
export default {
  name: 'BackButton',
  props: {
    link: String
  },
  mounted() {
  }
};
</script>

<style scoped>
.back-button {
  width: 100%;
  max-width: calc(var(--mid-width) + 20px);
}

a {
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  color: white;
}

img {
  filter: invert(100%);
}
</style>
